var React = require('react');

function ArrowRightLongSharpLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.551758 13.0518L0 12.5L0.551758 11.9482L7.58301 4.91699L8.13477 4.36523L9.24316 5.46875L8.69141 6.02051L2.99316 11.7188H24.2188H25V13.2812H24.2188H2.99316L8.68652 18.9795L9.24316 19.5312L8.13965 20.6348L7.58789 20.083L0.556641 13.0518H0.551758Z","fill":"white"}));
}

ArrowRightLongSharpLight.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = ArrowRightLongSharpLight;

ArrowRightLongSharpLight.default = ArrowRightLongSharpLight;
